import { useState } from 'react';

export const useStateObject = (initialFormValue = {}) => {
  const [value, setValue] = useState(initialFormValue);

  const updateValue = (field, updatedValue = '') => {
    if (!field) {
      return;
    }

    setValue((currentData) => ({
      ...currentData,
      [field]: updatedValue,
    }));
  };

  return {
    value,
    setValue,
    updateValue,
  };
};
